import React, { Component } from 'react';
import { PopUp,Content } from '@beisen/chaos-ui';
import * as helper from '../util/helper';
import { serializeUrl } from '../util/url';
import ListLoad from '../ListLoad/ListLoad';
require('./popIndexView.scss');

export default class PopIndexView extends Component {
    static defaultProps = {
        buttonData: {
            cmp_data: {

            }
        }
    };

    constructor(props) {
        super(props);
        this.handleClosePop = this.handleClosePop.bind(this);
        this.state = {
            loading: true
        };
    }

    componentWillMount() {
        if(window.env.platform.iTalentIOS) {
            localStorage.setItem('iTalentIOSPopData',JSON.stringify({ 'popViewData': this.props.buttonData || {}, 'popParams': this.indexParams() || {} }));
            window.env.on({
                name: 'iTalentIOS_pop_indexview_cancel'
            }, ret => {
                // 新窗口点击取消/返回后 清除button数据
                this.props.actions.customBtnClearFn();
                if(window.env.platform.iTalentIOS) {
                    window.unReloadTable = true; // 需要判断是否是在列表上点击的 todo
                }
            });

            const url = `${location.origin}${location.pathname}#/indexPage?${this.urlParmas()}`;
            helper.openUrlInNewWindow({ title: this.props.buttonData.cmp_data.title },url);
            return;
        }

        window.iTalentSDK.register([{
            listenEvent: 'pop_indexview_iframeready',
            context: this,
            cb: this.sendPopProps
        }]);
        window.iTalentSDK.register([{
            listenEvent: 'pop_indexview_cancel',
            context: this,
            cb: this.handleClosePop
        }]);
        if(!this.props.buttonData.cmp_data.title) {
            window.iTalentSDK.register([{
                listenEvent: 'pop_indexview_setTitle',
                context: this,
                cb: this.updateHeader
            }]);
        }
    }

    updateHeader(data) {
        helper.deletLastHeader();
        this.setBoxHeader(data.title);
    }

    //注册壳子回调函数
    registCallback() {
        window.globalEventManager['PopIndexViewHandleBack'] = this.handleClosePop.bind(this);
    }
    //清除壳子回调函数
    clearCallback() {
        delete window.globalEventManager['PopIndexViewHandleBack'];
    }
    //组件销毁后获取前一个壳子的配置对象并通知壳子进行更新
    getPreHeaderConfig() {
        helper.clearHeaderConfig();
    }
    //设置壳子的导航对象并通知壳子更新导航
    setBoxHeader(viewTitle) {
        const title = this.props.buttonData.cmp_data.title || viewTitle;
        helper.generateHeaderConfig(function(headerConfig, setButton) {
            let config = Object.assign({}, headerConfig);
            const left_item = [
                {
                    callback: 'PopIndexViewHandleBack',
                    control: true,
                    type: 'back'
                }
            ];
            config = setButton('left', left_item, config);
            config.titleItem = {
                text: title,
                icon: '',
                callback: '',
                control: false
            };
            return config;
        });
    }

    componentDidMount() {
        if (helper.ifHidePopupNav() && !window.env.platform.iTalentIOS) {
            this.registCallback();
            this.setBoxHeader();
        }
    }

    componentWillUnmount() {
        if(window.env.platform.iTalentIOS) {
            window.env.off({ name: 'iTalentIOS_pop_indexview_cancel' });
            localStorage.removeItem('iTalentIOSPopData');
            return;
        }
        if (helper.ifHidePopupNav()) {
            this.clearCallback();
            this.getPreHeaderConfig();
        }
    }

    sendPopProps() {
        // this.setState({ loading: false });
        window.iTalentSDK.sendMessage({
            publishEvent: 'pop_indexview',
            data: {
                popViewData: this.props.buttonData || {},
                popParams: this.indexParams() || {}
            }
        });
    }

    handleClosePop() {
        this.props.actions.customBtnClearFn();
    }
    // 将button params字符串转换成对象
    parseParams(stringParams) {
        if(!stringParams) return {};
        const params = {};
        stringParams.split(',').forEach(kv => {
            let items = kv.split(':');
            const key = items[0].trim();
            params[key] = items.length > 2 ? items[1].concat(':', items[2]) : items[1];
        });
        return params;
    }

    // 请求index接口参数
    indexParams() {
        const { Application,MetaObject,NavView } = this.parseParams(this.props.buttonData.cmp_data.extendParams);
        const extendParamsObj = {
            metaObjName: MetaObject,
            app: Application,
            navViewName: NavView,
            localApp: BSGlobal.application
        };
        return Object.assign({},extendParamsObj,this.props.buttonData.customIndexViewParams);
    }

    // iframe url参数
    urlParmas() {
        let params = {
            pageType: 'PopIndexView',
            localApp: BSGlobal.application
        };
        let queryObj = helper.getQueryObject();
        if(queryObj.shadow_context) {
            params['shadow_context'] = decodeURIComponent(queryObj.shadow_context);
        }
        return serializeUrl(params);
    }

    renderLoading() {
        if(!this.state.loading) return null;
        return <Content style={{ height: '100%' }}> <ListLoad style={{ height: '100%',background: '#f3f4f5' }} /> </Content>;
    }

    renderIframe() {
        const iframeUrl = `//${location.host}${location.pathname}#/indexPage?${this.urlParmas()}`;
        return <iframe style={{ 'border': 'none','width': '100%','height': '100%' }} src={iframeUrl}></iframe>;
    }

    render() {
        if(window.env.platform.iTalentIOS) {
            // italentios 加载iframe 导致返回不生效 因此改为打开新窗口
            return null;
        }
        return (<PopUp
                    visible={true}
                    animation="right-slide-fade"
                    maskAnimation="fade"
                    cls="indexview_popup"
                    maskClosable={false}
                    lazyRender={true}
                >
                    {/* {this.renderLoading()} */}
                    {this.renderIframe()}
                </PopUp>);
    }
}



// WEBPACK FOOTER //
// ./src/components/PopIndexView/PopIndexView.js